document.querySelectorAll('.js-video-bg').forEach((frame) => {
    const VIDEO = frame.querySelector('video');

    if (!VIDEO?.hasAttribute('loop') || !VIDEO.hasAttribute('autoplay')) {
        return;
    }

    VIDEO.play().catch((error) => {
        if (error.name !== 'NotAllowedError') {
            return;
        }

        const fallbackImg = frame.querySelector('.js-video-fallback-img');

        VIDEO.removeAttribute('autoplay');
        VIDEO.pause();
        frame.classList.add('is-autoplay-blocked');

        if (fallbackImg) {
            fallbackImg.removeAttribute('hidden');
            return;
        }

        if (!VIDEO.hasAttribute('poster')) {
            VIDEO.style.display = 'none';
        }
    });
});
